import { useNavigate } from 'react-router-dom';
import style from './article-list-item.module.scss';
import helperService from '../../../services/helper.service';
import { TArticle, TUser } from '../../../models/common';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';

interface ArticleListItemProps {
  article: TArticle;
}

function ArticleListItem({ article }: ArticleListItemProps) {
  const navigate = useNavigate();
  const newDate = new Date(article.created_at as string);

  const handleNavigate = () => {
    navigate(helperService.getNavigateLink(article));
  };
  return (
    <div onClick={handleNavigate} key={article._id} className={style['article-list-item']}>
      <div className={style.profile}>
        <ProfilePhoto
          user={article.publisher as TUser}
          height="1.5rem"
          width="1.5rem"
          fontSize="0.8rem"
          radius="100%"
        />
        <div className={style.user}>
          {(article.publisher as TUser).username +
            ' • ' +
            helperService.formatDateToMonthDayYear(newDate)}
        </div>
      </div>
      <div className={style.title}>{article.title}</div>
      {article.content && (
        <div
          className={style.articleContent}
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      )}
    </div>
  );
}

export default ArticleListItem;
